import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Col, Row } from "antd";
import { observer } from "mobx-react";
import { ExportForm } from "./export.js";
import { ExportConsentsForm } from "./exportConsents.js";
import { ImportForm } from "./import.js";
import { useConfigHintText } from "../../../hooks/useConfigHintText.js";
import { __ } from "../../../utils/i18n.js";
import { ConfigHintModal } from "../hintModal.js";
const ImportExportCards = observer(()=>{
    const hintText = useConfigHintText("import");
    return /*#__PURE__*/ _jsxs(Row, {
        children: [
            /*#__PURE__*/ _jsx(Col, {
                xl: 16,
                sm: 16,
                xs: 24,
                children: /*#__PURE__*/ _jsx(Card, {
                    style: {
                        margin: 10
                    },
                    title: __("Import"),
                    children: /*#__PURE__*/ _jsx(ImportForm, {})
                })
            }),
            /*#__PURE__*/ _jsxs(Col, {
                xl: 8,
                sm: 8,
                xs: 24,
                children: [
                    /*#__PURE__*/ _jsx(Card, {
                        style: {
                            margin: 10
                        },
                        title: __("Export"),
                        children: /*#__PURE__*/ _jsx(ExportForm, {})
                    }),
                    /*#__PURE__*/ _jsx(Card, {
                        style: {
                            margin: 10
                        },
                        title: __("Export consents"),
                        children: /*#__PURE__*/ _jsx(ExportConsentsForm, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                style: {
                    maxWidth: 800,
                    margin: "30px auto 0",
                    textAlign: "center"
                },
                children: hintText
            }),
            /*#__PURE__*/ _jsx(ConfigHintModal, {
                identifier: "import"
            })
        ]
    });
});
export { ImportExportCards };
